import { DEFAULT_CURRENCY_MASK } from "react-epharma-components/lib/index";
import { createNumberMask } from "text-mask-addons";

const DECIMAL_CURRENCY_MASK_CFG = {
  ...DEFAULT_CURRENCY_MASK,
};

const decimalMask = createNumberMask(DECIMAL_CURRENCY_MASK_CFG);

const toDecimal = (value: any) => {
  const decimalSymbol = DECIMAL_CURRENCY_MASK_CFG.decimalSymbol;
  let val = value + "";

  if (val.indexOf(".") > -1) {
    const beforeDecimals = val.substr(0, val.indexOf("."));
    const afterDecimals = val.substr(val.indexOf(".") + 1).padEnd(DECIMAL_CURRENCY_MASK_CFG.decimalLimit || 2, "0");
    val = beforeDecimals + decimalSymbol + afterDecimals;
  } else {
    val = val + "," + "0".padEnd(DECIMAL_CURRENCY_MASK_CFG.decimalLimit || 2, "0");
  }
  return val;
};

const { appService, clientService } = window;

const endpoints = {
  appNotifications: appService.base + appService.appNotifications,
  userActivation: appService.base + appService.appActivationUser,
  userActivationLog: appService.base + appService.appActivationUserLog,
  resetPassword: appService.base + appService.appUserResetPassword,
  servicesAssociations: appService.base + appService.servicesAssociations,
  servicesAssociationsLog: appService.base + appService.servicesAssociationsLog,
  parameter: appService.base + appService.parameter,
  flexParameterization: appService.base + appService.flexParameterization,
  epCare: appService.base + appService.epCare,
  aggregator: clientService.base + clientService.aggregator,
  client: clientService.base + clientService.client,
  benefit: clientService.base + clientService.benefit,
};

const apiSecurity = {
  defaultResetPasswordPrefix: appService.defaultResetPasswordPrefix,
  secretKey: appService.secretKey,
};

const helpers = {
  endpoints,
  apiSecurity,
  decimalMask,
  toDecimal,
};

export default helpers;
